<template>
  <div class="table-wrapper loading-wrapper" :class="{ 'is-loading' : isLoading }">
    <div class="table-switch" v-if="showShowAll">
      <span class="label">
        {{ $t('filter_show_all') }}
        <label>
          <input type="checkbox" value="1" v-model="showAll" @change="onChangeShowAll" />
          <span></span>
        </label>
      </span>
    </div>
    <div class="table-switch" v-if="showShowDeactivatedOnly">
      <span class="label">
        {{ $t('filter_show_all') }}
        <label>
          <input type="checkbox" value="1" v-model="showDeactivatedOnly" @change="onChangeShowDeactivatedOnly" />
          <span></span>
        </label>
      </span>
    </div>
    <table>
      <thead v-if="getHeaderRow">
        <tr>
          <template v-for="column in columns">
            <th
              :class="column.class"
              :style="column.width ? ('width: ' + column.width + '; min-width: ' + column.width) : ''"
            >{{ column.label }}</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <template v-if="rows.length === 0">
          <tr class="table-row-empty">
            <td :colspan="getVisibleColumns">{{ emptyMessage }}</td>
          </tr>
        </template>
        <template v-else v-for="(row, index) in rows">
          <tr
            :class="{ 'table-row-active' : isVisibleDetailRow(row[detailRowId]), 'odd' : index % 2 === 0 , 'even' : index % 2 !== 0, [rowClass(row, index)] : true}"
            @click="onClickRow(row, $event)"
          >
            <template v-for="column in columns">
              <td
                :class="column.class"
                :style="column.width ? ('width: ' + column.width + '; min-width: ' + column.width) : ''"
              >
                <slot :name="column.key" :row="row">{{ row[column.key] }}</slot>
              </td>
            </template>
          </tr>
          <template v-if="getDetailRow">
            <tr
              class="table-row-detail"
              :class="{ 'odd' : index % 2 === 0 , 'even' : index % 2 !== 0 }"
              v-show="isVisibleDetailRow(row[detailRowId])"
            >
              <td :colspan="getVisibleColumns">
                <slot name="detail-row" :row="row"></slot>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
    <div class="loading-message" v-if="isLoading">{{ $t('results_loading') }}</div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      default: []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    showAll: {
      type: Number,
      default: 0
    },
    showShowAll: {
      type: Boolean,
      default: true
    },
    showDeactivatedOnly: {
      type: Number,
      default: 0
    },
    showShowDeactivatedOnly: {
      type: Boolean,
      default: false
    },
    showHeaderRow: {
      type: Boolean,
      default: false
    },
    useDetailRow: {
      type: Boolean,
      default: false
    },
    detailRowId: {
      type: String,
      default: "id"
    },
    rowClass: {
      type: Function,
      default: () => ""
    },
    reloadTable: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      emptyMessage: this.$t("no_results_found"),
      rows: [],
      visibleDetailRow: null
    };
  },
  watch: {
    items: {
      handler: function(newVal, oldVal) {
        if (this.reloadTable) {
          this.updateTable();
        }
      },
      deep: true
    }
  },
  computed: {
    getHeaderRow: function() {
      return this.showHeaderRow;
    },
    getDetailRow: function() {
      return this.useDetailRow;
    },
    getVisibleColumns: function() {
      return this.columns.length;
    },
    getVisibleRows: function() {
      return this.rows.length;
    }
  },
  methods: {
    updateTable: function() {
      this.getTableRows();
    },
    getTableRows: function() {
      this.rows = [];

      var rows = [],
        formatters = this.getTableColumnFormatters();

      this.items.forEach(function(row) {
        row.unique = this.$moment().valueOf();

        formatters.forEach(function(formatter) {
          if (!row[formatter.key]) {
            row[formatter.key] = formatter.formatter(null, row);
          } else {
            row[formatter.key] = formatter.formatter(row[formatter.key], row);
          }
        });

        rows.push(row);
      }, this);

      setTimeout(
        function() {
          this.rows = rows;
        }.bind(this),
        1
      );
    },
    getTableColumnFormatters: function(key) {
      var columns = [];

      this.columns.forEach(function(column) {
        if (column.formatter) {
          columns.push({
            key: column.key,
            formatter: column.formatter
          });
        }
      });

      return columns;
    },
    isVisibleDetailRow: function(id) {
      return this.visibleDetailRow === id;
    },
    onShowDetailRow: function(id) {
      if (this.visibleDetailRow) {
        this.onHideDetailRow(this.visibleDetailRow);
      }

      this.visibleDetailRow = id;
    },
    onHideDetailRow: function(id) {
      this.visibleDetailRow = null;
    },
    onToggleDetailRow: function(id) {
      if (this.isVisibleDetailRow(id)) {
        this.onHideDetailRow(id);
      } else {
        this.onShowDetailRow(id);
      }
    },
    onClickRow: function(row, event) {
      var tag = event.target.tagName.toLowerCase();

      if (-1 === ["button", "a"].indexOf(tag)) {
        this.$emit("rowClicked", row);

        if (this.getDetailRow) {
          this.onToggleDetailRow(row[this.detailRowId]);
        }
      }
    },
    onChangeShowAll: function(event) {
      this.$emit("onChangeShowAll", event.target.checked ? 1 : 0);
    },
    onChangeShowDeactivatedOnly: function(event) {
      this.$emit("onChangeShowDeactivatedOnly", event.target.checked ? 1 : 0);
    },
  }
};
</script>